import React from 'react';
import PropTypes from 'prop-types';

export class LoadingIcon extends React.Component {
  render() {
    let {display, size, text} = this.props;

    if (!display) {
      return '';
    }
    let className = 'fas fa-spinner fa-spin';
    if (size) {
      className += ' fa-' + size;
    }
    return (
        <span className="pr-1">
          <i className={className}></i> {text}
        </span>
    );
  }
}

LoadingIcon.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'lg', '2x', '3x', '5x', '7x', '10x']),
  display: PropTypes.bool.isRequired,
  text: PropTypes.string,
};